const objFunc = () => {
  return {
    userIsTitleHolder: undefined,
    titleAddress: '',
    state: '',
    customerEstimate: '',
    estimatePercent: 0,
    description: '',
    year: '',
    make: '',
    model: '',
    series: '',
    style: '',
    vehicleMileage: '',
    brokenOdometer: false,
    lienHolderName: '',
    lienHolderPhone: '',
    lienHolderAccountNumber: '',
    estimatedPayoffAmount: undefined,
    vehicleEstimate: {},
    hasCoOwner: undefined,
    coOwnerFirstName: undefined,
    coOwnerMiddleName: undefined,
    coOwnerLastName: undefined,
    coOwnerSuffixName: undefined,
    registrationCounty: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
